/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EquipementDto } from '../../models/equipement-dto';

export interface GetEquipementsBySite$Params {
  /**
   * Id site
   */
  id_site?: string;
}

export function getEquipementsBySite(
  http: HttpClient,
  rootUrl: string,
  params?: GetEquipementsBySite$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<Array<EquipementDto>>> {
  const rb = new RequestBuilder(rootUrl, getEquipementsBySite.PATH, 'get');
  if (params) {
    rb.query('id_site', params.id_site, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<EquipementDto>>;
    })
  );
}

getEquipementsBySite.PATH = '/v1/equipements/bySite';
